// extracted by mini-css-extract-plugin
module.exports = {"loading-container":"_2U0Wzu0KpL5s5nhNIM6F3Y"};